"use strict" ;

import Zero from '../rules/Zero'

import IfTask from './IfTask'

/**
 * Perform some tasks based on whether a given value is <code>0</code>.
 * @name IfZero
 * @memberof system.logics
 * @extends system.logics.IfTask
 * @class
 * @see system.rules.Zero
 * @param {Object} value - The value to evaluate.
 * @param {system.process.Action} thenTask - The action to execute if the main condition if <code>true</code>.
 * @param {system.process.Action} elseTask - The action invoked if all the conditions failed.
 * @param {array} elseTask - The optional collection of {@link system.logics.ElseIf} tasks.
 */
export default function IfZero( value , thenTask /*Action*/ = null , elseTask /*Action*/ = null , ...elseIfTasks ) // jshint ignore:line
{
    IfTask.call( this , new Zero(value) , thenTask , elseTask ) ;
    if( elseIfTasks.length > 0 )
    {
        this.addElseIf.apply( this , elseIfTasks ) ;
    }
}

IfZero.prototype = Object.create( IfTask.prototype ,
{
    constructor : { writable : true , value : IfZero }
});